import { useState, useEffect, useCallback, useRef } from 'react';

const useSearchCounter = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://localhost:7110/api/';
  const [remainingSearches, setRemainingSearches] = useState(null);
  const [requiresPayment, setRequiresPayment] = useState(false);
  const fetchedRef = useRef(false);

  const refreshQuota = useCallback(async () => {
    try {
      const response = await fetch(`${apiBaseUrl}search/quota`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        const rp = data.requiresPayment ?? data.RequiresPayment ?? false;
        setRemainingSearches(data.remainingSearches ?? data.RemainingSearches ?? 0);
        setRequiresPayment(rp);
        return { requiresPayment: rp };
      }
    } catch {
      // Silently fail
    } finally {
    }
    return null;
  }, [apiBaseUrl]);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    refreshQuota();
  }, [refreshQuota]);

  const updateFromWebSocket = useCallback((data) => {
    if (data.remainingSearches !== undefined) setRemainingSearches(data.remainingSearches);
    if (data.requiresPayment !== undefined) setRequiresPayment(data.requiresPayment);
  }, []);

  const canSearch = !requiresPayment && (remainingSearches === null || remainingSearches > 0);

  return {
    remainingSearches,
    requiresPayment,
    isLoading: false,
    canSearch,
    refreshQuota,
    updateFromWebSocket,
  };
};

export default useSearchCounter;
